<template>
  <div id="bilder">
    <h1 style="margin-left: 10px;">Bilder</h1>
    <img
      class="fullscreen-img"
      v-for="n in 7"
      :key="n"
      :src="'/images/bild' + n + '.jpg'"
    >
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.fullscreen-img {
  width: 100%;
  border: 2px solid red;
  box-sizing: border-box;
  margin: 0px;
}
</style>

